import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { Button, Grid, IconButton, MenuList, Popover, Typography } from '@mui/material';
import React from 'react';

import { UserMenuItems } from './UserMenuItems';

interface Props {
  name: string;
  canViewOrEditSomeGlobalSettings: boolean;
  iconOnly?: boolean;
  maxWidth?: number;
}

export const UserMenu: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  canViewOrEditSomeGlobalSettings,
  iconOnly = false,
  maxWidth,
}) => {
  const [anchorActionListElement, setAnchorActionListElement] = React.useState<HTMLElement | null>(null);
  const welcomeText = `Hello, ${name}`;

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorActionListElement(event.currentTarget);
  };

  const welcomeLabel = (
    <Typography
      data-test-class="user-name"
      variant="body1"
      noWrap
      sx={{ minWidth: 0, flex: '1 1 auto', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      {welcomeText}
    </Typography>
  );

  return (
    <>
      <Grid
        item
        sx={{
          cursor: 'pointer',
          minWidth: 0,
          maxWidth: iconOnly ? '100%' : maxWidth || 240,
          display: 'flex',
          flex: iconOnly ? '0 0 auto' : '0 1 auto',
        }}
      >
        {iconOnly ? (
          <IconButton
            aria-label={`Open user menu for ${name}`}
            color="inherit"
            onClick={handleOpenMenu}
            title={welcomeText}
          >
            <MoreVertRoundedIcon />
          </IconButton>
        ) : (
          <Button
            aria-label={welcomeText}
            color="inherit"
            onClick={handleOpenMenu}
            endIcon={<MoreVertRoundedIcon />}
            title={welcomeText}
            sx={{
              textTransform: 'none',
              minWidth: 0,
              width: '100%',
              maxWidth: '100%',
              display: 'flex',
              alignItems: 'center',
              '& .MuiButton-endIcon': {
                flexShrink: 0,
              },
            }}
          >
            {welcomeLabel}
          </Button>
        )}
      </Grid>

      <Popover
        open={Boolean(anchorActionListElement)}
        anchorEl={anchorActionListElement}
        onClose={() => {
          setAnchorActionListElement(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <MenuList autoFocusItem>
          <UserMenuItems
            name={name}
            canViewOrEditSomeGlobalSettings={canViewOrEditSomeGlobalSettings}
            onClose={() => setAnchorActionListElement(null)}
            includeSupportItems
          />
        </MenuList>
      </Popover>
    </>
  );
};
